import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { Stack } from "@mui/material"
import { motion, AnimatePresence } from "framer-motion"
import { CREATE_ORDER_TOP_BAR_HEIGHT } from "../CreateOrderDialogTitle"

type StyleProps = Readonly<{
    isDrawerOpen: boolean
}>

export const DRAWER_WIDTH = "27.5rem"

const useStyles = makeStyles<StyleProps>()((theme, { isDrawerOpen }) => ({
    sideDrawerWrap: {
        flex: "none",
        width: isDrawerOpen ? DRAWER_WIDTH : "0",
        transition: "all 0.3s ease-in-out",
        position: "fixed",
        top: CREATE_ORDER_TOP_BAR_HEIGHT,
        right: 0,
        zIndex: "9999",
        background: theme.palette.common.white,
        borderLeft: `1px solid ${theme.palette.tailwind.slate[300]}`,
        height: `calc(100vh - ${CREATE_ORDER_TOP_BAR_HEIGHT})`,
        display: "flex",
    },
    content: {
        flexGrow: 1,
        padding: "1rem",
        justifyContent: "space-between",
    },
}))

type CreateOrderDialogDrawerProps = Readonly<
    PropsWithChildren<{
        open: boolean
    }>
>

export function CreateOrderDialogDrawer({ open, children }: CreateOrderDialogDrawerProps) {
    const { classes } = useStyles({ isDrawerOpen: open })

    return (
        <AnimatePresence>
            <motion.div
                className={classes.sideDrawerWrap}
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "100%", opacity: 0 }}
                transition={{ duration: 0.45, ease: "easeIn" }}
            >
                {open && (
                    <Stack gap="1.5rem" className={classes.content}>
                        {children}
                    </Stack>
                )}
            </motion.div>
        </AnimatePresence>
    )
}
